<template>
    <component :is="tag" :class="tag + ` chapter`">
        <slot></slot>
    </component>
</template>

<script>
    // <chapter tag="h2" class="ribbon">H2 Оберіть предмет</chapter>
    // <chapter tag="h3" class="ribbon">H3 Оберіть предмет</chapter>
    // <chapter tag="h4" class="ribbon">H4 Оберіть предмет</chapter>
    // <chapter tag="h5" class="ribbon">H5 Оберіть предмет</chapter>
    // <chapter tag="h6" class="ribbon">H6 Оберіть предмет</chapter>

    export default {
        name: 'chapter', // caption
        props: {
            tag: { type: String, default: 'h1', required: false }
        }
    }
</script>

<style scoped lang="scss">
    @import "~/scss/bootstrap-customize.scss";

    $chapters-margin: $headings-margin-bottom * 1.8;
    $chapters-padding: $headings-margin-bottom * 1.8;

    $chapters-padding-h2: $chapters-padding / 1.5;
    $chapters-padding-h3: $chapters-padding / 1.8;
    $chapters-padding-h4: $chapters-padding / 2;
    $chapters-padding-h5: $chapters-padding / 2.5;
    $chapters-padding-h6: $chapters-padding / 3;

    .chapter {
        font-family: 'Montserrat', sans-serif;
        letter-spacing: 0.12em; // $spacer | em или ex
        font-weight: 600;

        text-transform: uppercase;
        text-align: center;

        /*color: $gray-100;
        background: $green linear-gradient(to top right, $green, darken($green, 12%));
        text-shadow: 2px 2px 3px opacify(darken($green, 20%), 0.1);*/

        margin: $chapters-margin 0;
        padding: $chapters-padding 0;
    }

    h2.chapter { padding: $chapters-padding-h2; }
    h3.chapter { padding: $chapters-padding-h3; }
    h4.chapter { padding: $chapters-padding-h4; }
    h5.chapter { padding: $chapters-padding-h5; }
    h6.chapter { padding: $chapters-padding-h6; }


    // ~ ~ ~ Ribbon ~ ~ ~ //

    // @todo Исправить стиль для 2-х строчного заголовка!

    .chapter.ribbon_PLUG { position: relative; }
    .chapter.ribbon_PLUG:before, .chapter.ribbon_PLUG:after {
        content: '';
        position: absolute;
        z-index: 2;
        height: 100%;
        top: 0;
        bottom: 0;
        border-top:    1.1em solid transparent;
        border-bottom: 1.1em solid transparent;
    }

    .chapter.ribbon_PLUG:before { left: 0;  border-left: 20px solid #fff; }
    .chapter.ribbon_PLUG:after  { right: 0; border-right: 20px solid #fff; }

    $chapter-ribbon-h2: ($chapters-padding-h2 + $h2-font-size) / 1.4;
    h2.chapter.ribbon_PLUG:before, h2.chapter.ribbon_PLUG:after { border-top-width: $chapter-ribbon-h2; border-bottom-width: $chapter-ribbon-h2; }

    $chapter-ribbon-h3: ($chapters-padding-h3 + $h3-font-size) / 1.4;
    h3.chapter.ribbon_PLUG:before, h3.chapter.ribbon_PLUG:after { border-top-width: $chapter-ribbon-h3; border-bottom-width: $chapter-ribbon-h3; }

    $chapter-ribbon-h4: ($chapters-padding-h4 + $h4-font-size) / 1.4;
    h4.chapter.ribbon_PLUG:before, h4.chapter.ribbon_PLUG:after { border-top-width: $chapter-ribbon-h4; border-bottom-width: $chapter-ribbon-h4; }

    $chapter-ribbon-h5: ($chapters-padding-h5 + $h5-font-size) / 1.4;
    h5.chapter.ribbon_PLUG:before, h5.chapter.ribbon_PLUG:after { border-top-width: $chapter-ribbon-h5; border-bottom-width: $chapter-ribbon-h5; }

    $chapter-ribbon-h6: ($chapters-padding-h6 + $h6-font-size) / 1.4;
    h6.chapter.ribbon_PLUG:before, h6.chapter.ribbon_PLUG:after { border-top-width: $chapter-ribbon-h6; border-bottom-width: $chapter-ribbon-h6; }
</style>